.InfoIcon3678204901__root {
  -st-states:
    icon(enum(info, error)),
    size(enum(small, medium));

  display: inline-flex;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
}

.InfoIcon3678204901__root:focus {
  outline: 2px solid #80b1ff;
}

.InfoIcon3678204901__root.InfoIcon3678204901---size-6-medium {
  margin: 3px;
}

.InfoIcon3678204901__root.InfoIcon3678204901---icon-4-info {
  color: #868aa5;
}

.InfoIcon3678204901__root.InfoIcon3678204901---icon-5-error {
  color: #e62214;
}

.InfoIcon3678204901__root[disabled] {
  color: #acafc4;
}

.InfoIcon3678204901__root:not([disabled]).InfoIcon3678204901---icon-4-info:hover,
.InfoIcon3678204901__root:not([disabled]).InfoIcon3678204901---icon-4-info:focus {
  color: #116dff;
}

/* st-namespace-reference="../../../../src/atoms/InfoIcon/InfoIcon.st.css" */